import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchTagsFilterEntity } from '../../domain/entities/BranchTagsFilterEntity'

export class BranchTagsFilterModel extends BranchTagsFilterEntity {
  channelIds?: Array<number>

  constructor(dataDto: BranchTagsFilterEntity) {
    super()
    mapEntityProperties<BranchTagsFilterModel>(this, dataDto, {
      exclude: ['channels'],
      map: {
        channelIds: dataDto.channels?.map((channel) => channel.id)
      }
    })
  }
}
